import React from "react";
import { Link, useNavigate} from 'react-router-dom';
import{ MdLayers, MdTranslate} from 'react-icons/md';
import{ GiMedicines } from 'react-icons/gi';

import dodoImg from '../../assets/img/dodo_image.png';
import './style.css'



export default function Home(){
    

    return(  
        <div className="intro-container">
            
            <img src={dodoImg} alt = "Dodo" />
            
            <div className="btn-container">
                <Link className="btn-link" to={"/chat"}>
                    <GiMedicines 
                        className="btn-img" 
                        size={32} 
                        color="#1ABC9C" 
                    />
                    Medicamento
                </Link>

                <Link className="btn-link" to={"/translate"}>
                    <MdTranslate 
                        className="btn-img" 
                        size={32} 
                        color="#1ABC9C" 
                    />
                    Traduzir
                </Link>

                <Link className="btn-link" to={""}>
                    <MdLayers
                        className="btn-img" 
                        size={32} 
                        color="#1ABC9C" 
                    />
                    Historico
                </Link>
                
            </div>
                
        </div>
       
    )
}